import type { AuditFilterParams } from "@/api/audit";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

interface Props {
  value: AuditFilterParams;
  onChange: (v: AuditFilterParams) => void;
  onApply: () => void;
}

const COMMON_TARGETS = [
  "",
  "form_definitions",
  "workflow_definitions",
  "notification_rules",
  "users",
  "field_overrides",
  "secret_store",
  "tenant_settings",
  "translations",
];

const COMMON_ACTIONS = [
  "",
  "create",
  "update",
  "delete",
  "publish",
  "rollback",
  "login",
  "logout",
];

export function AuditFilters({ value, onChange, onApply }: Props): JSX.Element {
  return (
    <div className="rounded-md border bg-background p-3 space-y-2">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
        <div>
          <label className="text-xs font-medium block mb-1">User ID (UUID)</label>
          <Input
            value={value.user_id ?? ""}
            onChange={(e) =>
              onChange({ ...value, user_id: e.target.value || undefined })
            }
            placeholder="optional UUID"
            className="h-8 text-sm font-mono"
          />
        </div>
        <div>
          <label className="text-xs font-medium block mb-1">Target model</label>
          <select
            value={value.target_model ?? ""}
            onChange={(e) =>
              onChange({
                ...value,
                target_model: e.target.value || undefined,
              })
            }
            className="w-full h-8 rounded-md border bg-background px-2 text-sm"
          >
            {COMMON_TARGETS.map((t) => (
              <option key={t} value={t}>
                {t || "(any)"}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label className="text-xs font-medium block mb-1">Action</label>
          <select
            value={value.action ?? ""}
            onChange={(e) =>
              onChange({ ...value, action: e.target.value || undefined })
            }
            className="w-full h-8 rounded-md border bg-background px-2 text-sm"
          >
            {COMMON_ACTIONS.map((a) => (
              <option key={a} value={a}>
                {a || "(any)"}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label className="text-xs font-medium block mb-1">Days back</label>
          <Input
            type="number"
            min={1}
            max={365}
            value={value.days_back ?? 30}
            onChange={(e) =>
              onChange({
                ...value,
                days_back: e.target.value ? Number(e.target.value) : 30,
              })
            }
            className="h-8 text-sm"
          />
        </div>
      </div>
      <div className="flex justify-end gap-2 pt-1">
        <Button
          size="sm"
          variant="outline"
          onClick={() =>
            onChange({
              days_back: value.days_back ?? 30,
            })
          }
        >
          Reset
        </Button>
        <Button size="sm" onClick={onApply}>
          Apply filter
        </Button>
      </div>
    </div>
  );
}
